import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:8000/api';

const api = axios.create({
  baseURL: API_URL,
  headers: {
    'Content-Type': 'application/json'
  }
});

// Add token to requests if available
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Auth services
export const authService = {
  login: async (email, password) => {
    const response = await api.post('/auth/login', { email, password });
    if (response.data.token) {
      localStorage.setItem('token', response.data.token);
      localStorage.setItem('user', JSON.stringify(response.data.user));
    }
    return response.data;
  },

  register: async (username, email, password, role = 'user') => {
    const response = await api.post('/auth/register', { username, email, password, role });
    if (response.data.token) {
      localStorage.setItem('token', response.data.token);
      localStorage.setItem('user', JSON.stringify(response.data.user));
    }
    return response.data;
  },

  logout: () => {
    localStorage.removeItem('token');
    localStorage.removeItem('user');
  },

  getCurrentUser: () => {
    const userStr = localStorage.getItem('user');
    return userStr ? JSON.parse(userStr) : null;
  },

  isAdmin: () => {
    const user = authService.getCurrentUser();
    return user && user.role === 'admin';
  }
};

// Post services
export const postService = {
  getAllPostsAdmin: async () => {
    const response = await api.get('/posts/admin');
    return response.data;
  },

  getPaginatedPosts: async (page = 1, limit = 9) => {
    const response = await api.get(`/posts?page=${page}&limit=${limit}`);
    return response.data;
  },

  getPost: async (id) => {
    const response = await api.get(`/posts/${id}`);
    return response.data;
  },

  createPost: async (title, body) => {
    const response = await api.post('/posts', { title, body });
    return response.data;
  },

  updatePost: async (id, title, body) => {
    const response = await api.put(`/posts/${id}`, { title, body });
    return response.data;
  },

  deletePost: async (id) => {
    const response = await api.delete(`/posts/${id}`);
    return response.data;
  },

  // NEW - Search posts
  searchPosts: async (query) => {
    const response = await api.get(`/posts/search?q=${encodeURIComponent(query)}`);
    return response.data;
  },

  // NEW - Get most viewed posts
  reuploadPost: async () => {
    const response = await api.post('/posts/reupload');
    return response.data;
  },

  getMostViewedPosts: async (limit = 3) => {
    const response = await api.get(`/posts/most-viewed?limit=${limit}`);
    return response.data;
  }
};

export default api;
